import React, { useRef, useEffect, useState } from 'react';

import { injectedComponent } from '@base/core';

export default injectedComponent(
  {
    name: 'DefaultAvatar',
    styles: ['avatar'],
  },
  function DefaultAvatar({ initials, styles: { avatar: avatarStyles } }) {
    const ref = useRef();
    const [size, setSize] = useState(0);
    const style = size ? { fontSize: size / 2.3 } : {};

    useEffect(() => {
      const element = ref.current;
      if (!element) return;

      const updateSize = () => {
        const rect = element.getBoundingClientRect();
        if (rect.height > 0) {
          setSize(rect.height);
        }
      };

      // Initial size calculation
      updateSize();

      // Use ResizeObserver if available, otherwise fallback to window resize
      if (typeof ResizeObserver !== 'undefined') {
        const resizeObserver = new ResizeObserver(updateSize);
        resizeObserver.observe(element);

        return () => {
          resizeObserver.disconnect();
        };
      } else {
        // Fallback for browsers without ResizeObserver
        window.addEventListener('resize', updateSize);
        return () => {
          window.removeEventListener('resize', updateSize);
        };
      }
    }, []);

    return (
      <div ref={ref} className={avatarStyles.defaultAvatar} style={style}>
        {initials}
      </div>
    );
  }
);
